import React from "react";
import { Lock } from "lucide-react";
import { Screen, Card } from "./ui";

const d10 = (x) => (x || "").slice(0, 10).split("-").reverse().join("/");
export const aud = (n) => `${Number(n || 0) < 0 ? "-" : ""}$${Math.abs(Number(n || 0)).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// read-only purchase (old Spa Buddy sales have no work order behind them)
export default function SaleView({ s, name, nav }) {
  const row = (l, v) => v ? <div className="flex justify-between gap-2 text-[15px]"><span className="text-slate-500">{l}</span><span className="font-bold text-slate-800 text-right">{v}</span></div> : null;
  return (
    <Screen title={`Purchase #${s.sale_number || "—"}`} sub={name} onBack={nav.back} testid="tech-sale-view">
      <Card className="flex items-center gap-2 bg-slate-800 text-white text-[15px] font-black" data-testid="tech-sale-locked"><Lock className="h-5 w-5" />Locked · read only</Card>
      <Card className="space-y-1.5">
        {row("Date", d10(s.created_at))}
        {row("Invoice to", s.invoice_to)}
        {row("Salesperson", s.salesperson || s.employee)}
        {row("Status", s.status)}
        {row("Delivered", d10(s.delivery_date))}
        {row("Invoice sent", d10(s.invoice_sent_date))}
      </Card>
      <Card className="space-y-2" data-testid="tech-sale-items">
        <div className="text-[13px] font-black text-slate-500">ITEMS</div>
        {(s.items || []).map((i, n) => <div key={n} className="flex justify-between gap-2 text-[16px]"><span>{i.qty}× {i.name}</span><span className="text-slate-600">{aud(i.line_total)}</span></div>)}
        {!(s.items || []).length && <div className="text-slate-500">No items on file.</div>}
      </Card>
      <Card className="space-y-1.5">
        {!!s.discount && row("Discount", aud(s.discount))}
        {row("GST", aud(s.gst_total))}
        <div className="flex justify-between text-[19px] font-black text-[#0f2f52]" data-testid="tech-sale-total"><span>Total</span><span>{aud(s.total)}</span></div>
        {!!s.balance_due && row("Balance due", aud(s.balance_due))}
        {(s.payments || []).map((p, n) => <div key={n}>{row(`Paid ${d10(p.date)}${p.method && p.method !== "legacy" ? ` · ${p.method}` : ""}`, aud(p.amount))}</div>)}
      </Card>
      {s.note && <Card className="text-[15px] text-amber-900 bg-amber-50 whitespace-pre-wrap">{s.note}</Card>}
    </Screen>
  );
}
